import React from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import routes from 'constants/routes';
import Demo from 'pages/Demo';
import ErrorPage from 'pages/Error';
import Goodie from 'pages/Goodie';
import HomePage from 'pages/Home';
import HomeV2 from 'pages/HomeV2';
import Imprint from 'pages/Imprint';
import Policy from 'pages/Policy';

import PageViewTracker from './PageViewTracker';

// Layout route: gives route-level components (page view tracking) access to
// the router context without changing what each page renders.
const RootLayout = () => (
  <>
    <PageViewTracker />
    <Outlet />
  </>
);

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: routes.home,
        element: <HomeV2 />,
        errorElement: <ErrorPage />,
      },
      {
        path: routes.old,
        element: <HomePage />,
        errorElement: <ErrorPage />,
      },
      {
        path: routes.goodie,
        element: <Goodie />,
        errorElement: <ErrorPage />,
      },
      {
        path: routes.demo,
        element: <Demo />,
        errorElement: <ErrorPage />,
      },
      {
        path: routes.imprint,
        element: <Imprint />,
        errorElement: <ErrorPage />,
      },
      {
        path: routes.policy,
        element: <Policy />,
        errorElement: <ErrorPage />,
      },
    ],
  },
]);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
